var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"DateInput",class:_vm.modifiers,attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":_vm.update,"blur":_vm.pad}})}
var staticRenderFns = []

export { render, staticRenderFns }